import SearchIcon from "./components/headerItems/SearchIcon.svelte";

new SearchIcon({
  target: document.querySelector("#squirrel_searchIcon")!.parentElement as HTMLElement
});
